import { render } from "./Reminder.vue?vue&type=template&id=3217c9ac"
import script from "./Reminder.vue?vue&type=script&setup=true&lang=js"
export * from "./Reminder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reminder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3217c9ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3217c9ac', __exports__)) {
    api.reload('3217c9ac', __exports__)
  }
  
  module.hot.accept("./Reminder.vue?vue&type=template&id=3217c9ac", () => {
    api.rerender('3217c9ac', render)
  })

}


export default __exports__